module.exports = __webpack_public_path__ + "img/no-signal.792777f0.gif";